import { ZfBox, ZfCard, ZfCardMedia, ZfIcon, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useElementHovering } from '../../../../family-tree';
import { getImageUrlByString } from '../../../../styles/assets/imageMap';
import { useShadowRootCustomStyles } from '../../../hooks/useShadowRootCustomStyles';
import type { IThinTopic } from '../../../interfaces/topic';

interface IProps {
    topic: IThinTopic;
    inverted?: boolean;
    isPinned?: boolean;
    onTopicClick: (topic: IThinTopic) => void;
}

export const AdminTopicCard: FunctionComponent<IProps> = ({ topic, inverted, isPinned, onTopicClick }) => {
    const { i18n, t } = useTranslation();
    const cardRef = useRef<HTMLZfCardElement>(null);
    const isHovering = useElementHovering(cardRef);

    useShadowRootCustomStyles(cardRef, '.card { border: none !important; }');

    return (
        <ZfCard key={topic.key} ref={cardRef} className="topic-card" onClick={() => onTopicClick(topic)}>
            <ZfCardMedia style={{ width: '15vw', height: '15vw' }} image={getImageUrlByString(topic.key)}>
                {isHovering ? (
                    <div
                        style={{
                            height: '15vw',
                            width: '15vw',
                            background: 'var(--fg-color-action-normal)',
                            opacity: '0.5',
                            position: 'absolute',
                            marginTop: '-12px',
                            marginLeft: '-12px',
                            borderRadius: '3px',
                        }}
                    />
                ) : null}
                <ZfBox
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'grid',
                        justifyItems: 'center',
                        alignItems: 'center',
                        gridTemplateAreas: inverted ? `"title" "icons" "details"` : `"details" "icons" "title"`,
                        gridTemplateRows: inverted ? '25% 25% auto' : 'auto 25% 25%',
                        gridTemplateColumns: '1fr',
                    }}
                >
                    <ZfBox style={{ gridArea: 'icons', alignSelf: inverted ? 'start' : 'end' }}>
                        <ZfBox
                            style={{
                                background: '#fff',
                                display: 'flex',
                                opacity: isPinned ? 1 : 0,
                                flexDirection: 'row',
                                alignItems: 'center',
                                alignSelf: 'end',
                                padding: '8px',
                                paddingRight: '16px',
                                borderRadius: 38,
                            }}
                        >
                            <ZfIcon name="circle" style={{ fill: '#459083', marginRight: '4.8px', width: 13, height: 13 }} />
                            <ZfTypography variant="body-medium">{t('sessionActive')}</ZfTypography>
                        </ZfBox>
                    </ZfBox>
                    <ZfBox style={{ gridArea: 'title' }}>
                        <ZfTypography
                            variant="body-extra-large"
                            style={{
                                color: '#fff',
                                alignSelf: 'center',
                            }}
                        >
                            {topic.name[i18n.language]}
                        </ZfTypography>
                    </ZfBox>
                </ZfBox>
            </ZfCardMedia>
        </ZfCard>
    );
};
